import ShippingPage from '../../components/ShippingPage';
import ShippingRestrictionForm from '../components/ShippingRestrictionForm';
import { useShippingRestrictionPage } from '../hooks';

function NewShippingRestrictionPage(): JSX.Element {
  const {
    values,
    handleOnSubmit,
    handleChange,
    setFieldValue,
    errors,
    isUpdating,
    isLoadingError,
    title,
    isConfirmDisabled,
  } = useShippingRestrictionPage({ mode: 'create' });

  return (
    <ShippingPage
      title={title}
      handleSave={handleOnSubmit}
      isUpdating={isUpdating}
      isError={isLoadingError}
      isConfirmDisabled={isConfirmDisabled}
    >
      {!isLoadingError && (
        <ShippingRestrictionForm
          values={values}
          onChange={handleChange}
          onArrayChange={setFieldValue}
          errors={errors}
        />
      )}
    </ShippingPage>
  );
}

export default NewShippingRestrictionPage;
